export const fallbackTestimonials = [
  {
    quote: 'ASTEM Software Lab transformed our school operations. The system is fast, user-friendly, and reliable.',
    name: 'Mrs. Adjoa K.',
    role: 'School Administrator',
  },
  {
    quote: 'Our business now runs smarter thanks to ASTEM analytics tools. Highly recommended.',
    name: 'Kwame B.',
    role: 'CEO, TechFarm GH',
  },
  {
    quote: 'Their customer support is top-notch. ASTEM Software Lab delivers exactly what you need.',
    name: 'Anita D.',
    role: 'NGO Director',
  },
  {
    quote: 'From consultation to deployment, ASTEM Software Lab was professional, efficient, and exceeded expectations.',
    name: 'Pastor Yaw M.',
    role: 'Church Planter',
  },
];
